import React, { memo } from 'react';
import clsx from 'clsx';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from '@americanexpress/dls-react';
import { roomDefaults, useRoomsContext } from '../../contexts/roomsContext';
import { useConfigContext } from '../../contexts/configContext';
import { useRefsContext } from '../../contexts/refsContext';
import { countTravelersFromRooms } from '../../utils/roomReducerUtil';
import { useMosaicContext } from '../../contexts/mosaicContext';

const AddRoomButton = memo(() => {
  const { rooms, addRoom } = useRoomsContext();
  const {
    hasRooms, maxRooms, moduleId, maxTravelersCap,
  } = useConfigContext();
  const { addRoomButton: ref } = useRefsContext();
  const travelers = countTravelersFromRooms(rooms);
  const isMosaicDesign = useMosaicContext();
  const totalTravelers = travelers
    + roomDefaults.adults
    + roomDefaults.children.length
    + roomDefaults.infants.length;
  const willExceedTotalTravelers = isMosaicDesign ? totalTravelers > maxTravelersCap : false;
  const showAddRoomBtn = hasRooms
    && rooms.length < maxRooms
    && !willExceedTotalTravelers;

  const { formatMessage } = useIntl();

  const ariaLabel = `${formatMessage({ id: 'add_room' })}`;

  const handleAddRoom = () => {
    addRoom();
  };
  return (
    <Button
      aria-label={ariaLabel}
      className={clsx(
        'width-full fluid text-center flex-justify-center',
        showAddRoomBtn ? 'flex' : 'hidden',
        isMosaicDesign ? 'margin-b' : 'margin-auto'
      )}
      aria-disabled={!showAddRoomBtn}
      id={`${moduleId}_addRoomButton`}
      type="button"
      onClick={handleAddRoom}
      ref={ref}
      variant="secondary"
    >
      <FormattedMessage id="add_room" />
    </Button>
  );
});

AddRoomButton.displayName = 'AddRoomButton';

export default AddRoomButton;
